import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button, Modal, Card, Input, message, Badge, Row, Col, Statistic, Progress, Tag, Segmented } from "antd";
import {
  DashboardOutlined,
  FieldTimeOutlined,
  ScheduleOutlined,
  HourglassOutlined,
  CalendarFilled,
  ClockCircleFilled,
  FileProtectOutlined,
  RedoOutlined,
  GiftOutlined,
  WalletOutlined,
  TeamOutlined,
  ClusterOutlined,
  BarChartOutlined,
  ExclamationCircleOutlined,
  CheckSquareOutlined,
  UsergroupAddOutlined,
  InboxOutlined,
  FieldBinaryOutlined,
  SyncOutlined,
  ApartmentOutlined,
  ExperimentOutlined,
  SafetyCertificateOutlined,
  WarningOutlined,
  FileTextOutlined,
  LineChartOutlined,
  UserAddOutlined,
  FileAddOutlined,
  FileSearchOutlined,
  AuditOutlined,
  CustomerServiceOutlined,
  PlusCircleOutlined,
  FolderViewOutlined,
  NotificationOutlined,
  ThunderboltOutlined,
  MoreOutlined,
  LogoutOutlined,
  FileDoneOutlined,
  SearchOutlined,
  FormOutlined,
  MenuOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  FundOutlined,
  CheckCircleOutlined,
  UserOutlined,
  HistoryOutlined
} from "@ant-design/icons";

import UserImg from "../../assests/user_avatar.png";
import { AuthContext } from "../../context/AuthContext";
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer } from "recharts";
import { useNavigation } from "../../context/NavigationContext";
import DashboardHeader from "../../components/dashboardheader/DashboardHeader";
import Footer from "../../components/footer/Footer";
import CreateMrf from "./CreateMrf";
import EmployeeViewReq from "./EmployeeViewReq";
import InterviewPage from "../interviewpage/InterviewPage";
import Holidays from "./Holidays";
import ViewAnnouncement from "../../components/employee/ViewAnnouncement";
import OffDay from "../../components/employee/OffDay";
import Permission from "../../components/employee/Permission";
import Leaves from "../../components/employee/Leaves";
import Teamleaves from "../../components/Teamleaves";
import TeamCompoff from "../../components/employee/TeamCompoff";
import Welcome from "../../components/Welcome";
import TeamPermissions from "../../components/TeamPermissions";
import RaiseTicket from "../../components/employee/RaiseTicket";
import ViewTicket from "../../components/employee/ViewTicket";
import PaySlip from "../../components/PaySlip";
import axios from "axios";
import TeamAttendance from "../../components/TeamAttendance";
import ViewEmpAttendance from "../../components/attendance/viewEmpAttendance";
import WeekOffCancel from "../../components/employee/WeekOffCancel";
import Rfc from "../../components/Rfc";
import ProbationReview from "../../components/employee/ProbationReview";
import SelfAssessment from "../../components/selfAssessment";
import BirthDayTemplate from "../../components/BirthDayTemplate";
import ViewBirthDay from "../../components/ViewBirthDay";
import WorkAnniversary from "../../components/WorkAnniversary";
import WorkCard from "../../components/WorkCard";
import OverallEmployees from "../../components/employee/OverallEmployees";
import Otapplication from "../../components/employee/Otapplication";
import OtApprovals from "../../components/OtApprovals";
import ListTickets from "../../components/ListTickets";
import "./EmployeeDashboard.css"
import TeamAssessment from "../TeamAssessment";
import Resignation from "../Resignation";
import ResignationRequests from "../ResignationRequests";
import LeaveCalendar from "../../components/employee/LeaveCalendar";
import { motion } from "framer-motion";
import { Sparkles, ShieldCheck, Zap, Calendar as LucideCalendar, User as LucideUser, Clock as LucideClock, FileText, Wallet as LucideWallet, Users, Award } from "lucide-react";
import EmployeeProfile from "../EmployeeProfile";
import Pips from "./Pips";
import InduvidualAttendance from "./InduvidualAttendance";
import OrgChart from "../OrgChart";
import ListNoc from "../ListNoc";
import ExitInterview from "../ExitInterview";
import PastOnduty from "./PastOnduty";
import TeamMembers from "../hod/TeamMembers";
import MyRfc from "../../components/employee/MyRfc";
import OnDutyAttendance from "../../components/OndutyAttendance";
import AppliedOnDuty from "./AppliedOnDuty";
import VersionUpdate from "../VersionUpdate";
import ViewAppVersions from "./ViewAppVersions";
import NoticeEmployees from "../../components/employee/NoticeEmployees";


const today = new Date();
const formattedDate = today.toLocaleDateString('en-GB');
console.log(formattedDate);

const { Sider, Content } = Layout;
const { TextArea } = Input;

export default function EmployeeDashboard() {
  const { authData, backUrl } = useContext(AuthContext);
  const { registerNavigator } = useNavigation();
  const [showWishes, setShowWishes] = useState(false);

  const [showWelcome, setShowWelcome] = useState(true);
  const [isHR, setIsHr] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [celebrations, setCelebrations] = useState({ birthdays: [], work_anniversaries: [] });
  const [eventsModalVisible, setEventsModalVisible] = useState(false);
  const [reportingEmployee, setReportingEmployee] = useState(null);
  const [showMRF, setShowMRF] = useState(false);
  const [isSuperUser, setIsSuperUser] = useState(false);
  const [wishModalVisible, setWishModalVisible] = useState(false);
  const [wishMessage, setWishMessage] = useState("");
  const [mywishes, setMyWishes] = useState([]);
  const [selectedPerson, setSelectedPerson] = useState(null);

  // Profile is now handled via selectedMenu === 'profile'
  const [isHovered, setIsHovered] = useState(false);

  const [isEmployeeView, setIsEmployeeView] = useState(
    localStorage.getItem("Hrselected") === "employee"
  );

  const [checkData, setCheckData] = useState(null)

  const [wishes, setWishes] = useState([]);

  const isMobile = window.innerWidth < 480;
  const isTab = window.innerWidth < 768;

  const [selectedMenu, setSelectedMenu] = useState(() => {
    // Priority: 1. LocalStorage (from notification click) 2. Fallback to 'home'
    const savedPage = localStorage.getItem("employeeDashboardPage");
    if (savedPage) return savedPage;
    return "home";
  });

  const [dashboardMode, setDashboardMode] = useState("self"); // "self" | "team"
  const [activeTeamTab, setActiveTeamTab] = useState("present");

  // Register this dashboard's menu setter so NotificationBar can navigate into it
  useEffect(() => {
    const cleanup = registerNavigator((menuKey) => setSelectedMenu(menuKey));
    return cleanup;
  }, [registerNavigator]);

  useEffect(() => {
    localStorage.setItem("employeeDashboardPage", selectedMenu);
    if (authData?.employee?.is_superuser === true) {
      setIsSuperUser(true);
    }
  }, [selectedMenu]);

  useEffect(() => {
    const welcomeShown = localStorage.getItem("welcomeShown");
    if (welcomeShown) {
      setShowWelcome(true);
      setTimeout(() => {
        localStorage.setItem("welcomeShown", "false");
        setShowWelcome(false);
      }, 3000);
    }
  }, []);

  const fetchWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/today/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setCelebrations(res.data);
    } catch (error) {
      console.error("Error fetching celebrations:", error);
    }
  };

  const [leaveDetails, setLeaveDetails] = useState(null);

  const getLeaveSummary = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/hr/leave-summary/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setLeaveDetails(res.data);
    }
    catch (error) {
      console.error("Error fetching leaves:", error);

    }
  }

  useEffect(() => {
    getLeaveSummary();
  }, []);

  const fetchMyWishes = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/probation/celebrations/my/`, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });
      setMyWishes(res.data);
    } catch (error) {
      console.error("Error fetching celebrations:", error);
    }
  };

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        const Cdata = localStorage.getItem("Hrselected");
        if (Cdata === "employee") setIsHr(true);
        else setIsHr(false);

        const res = await axios.get(
          `${backUrl}/api/emp/employees/${authData.employee.reporting_to}`,
          {
            headers: { Authorization: `Bearer ${authData?.access}` },
          }
        );
        setReportingEmployee(res.data);
      } catch (error) {
        console.error("Error fetching employee:", error);
      }
    };
    fetchEmployee();
    fetchWishes();
    fetchMyWishes();
  }, [authData, backUrl]);

  const checkEmployeeAccess = async () => {
    const res = await axios.get(`${backUrl}/api/emp/my-team/count/`, {
      headers: {
        Authorization: `Bearer ${authData?.access}`
      }
    });

    setCheckData(res.data)
    if (res.data.team_count !== 0 || authData?.employee?.is_hr === true) {
      setShowMRF(true)
    }
    else {
      setShowMRF(false)
    }
  }

  const [teamAttendanceData, setTeamAttendanceData] = useState(null);
  const [teamPendingData, setTeamPendingData] = useState(null);
  const [memberCategoryModal, setMemberCategoryModal] = useState({ visible: false, title: "", members: [], color: "" });
  const [searchModalQuery, setSearchModalQuery] = useState("");

  const fetchTeamTodayAttendance = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/my-team/attendance-today/`, {
        headers: { Authorization: `Bearer ${authData?.access}` }
      });
      setTeamAttendanceData(res.data);
    } catch (err) {
      console.error("Error fetching team today attendance:", err);
    }
  };

  const fetchTeamPendingRequests = async () => {
    try {
      const res = await axios.get(`${backUrl}/api/emp/my-team/pending-requests/`, {
        headers: { Authorization: `Bearer ${authData?.access}` }
      });
      setTeamPendingData(res.data);
    } catch (err) {
      console.error("Error fetching team pending requests:", err);
    }
  };

  useEffect(() => {
    if (dashboardMode === "team") {
      fetchTeamTodayAttendance();
      fetchTeamPendingRequests();
    }
  }, [dashboardMode]);

  useEffect(() => {
    checkEmployeeAccess();
  }, []);

  const handleOpenWishModal = (person) => {
    setSelectedPerson(person);
    setWishModalVisible(true);
  };

  const handleSendWish = async () => {
    try {
      const payload = {
        receiver_id: 343,
        occasion: "BIRTHDAY",
        message: "Happy Birthday Mithun! 🎉",
      };

      await axios.post(`${backUrl}/api/probation/celebrations/send/`, payload, {
        headers: { Authorization: `Bearer ${authData?.access}` },
      });

      message.success(`Wish sent successfully!`);
      setWishModalVisible(false);
      setWishMessage("");
    } catch (error) {
      console.error("Error sending wish:", error);
      message.error("Failed to send wish. Try again later.");
    }
  };

  const handleBack = () => {
    setSelectedMenu("home");
  }

  const LeaveSummary = ({ data }) => {
    const { allotments, balances, totals } = data;

    const clTotal = allotments?.CL || 0;
    const clTaken = totals?.CL_Taken || 0;
    const clBal = balances?.CL || 0;

    const slTotal = allotments?.SL || 0;
    const slTaken = totals?.SL_Taken || 0;
    const slBal = balances?.SL || 0;

    const compoffTotal = allotments?.Compoff || 0;
    const compoffTaken = totals?.Compoff_Taken || 0;
    const compoffBal = balances?.Compoff || 0;

    const weekoffTotal = allotments?.WeekOff || 0;
    const weekoffTaken = totals?.WeekOff_Taken || 0;
    const weekoffBal = balances?.WeekOff || 0;

    const compWeekTotal = compoffTotal + weekoffTotal;
    const compWeekBalTotal = compoffBal + weekoffBal;

    const clPct = clTotal > 0 ? Math.min(100, Math.round((clBal / clTotal) * 100)) : 0;
    const slPct = slTotal > 0 ? Math.min(100, Math.round((slBal / slTotal) * 100)) : 0;
    const compWeekPct = compWeekTotal > 0 ? Math.min(100, Math.round((compWeekBalTotal / compWeekTotal) * 100)) : 0;

    return (
      <div style={{ width: "100%" }} className="mb-4">
        <Card
          title={
            <div className="d-flex align-items-center gap-2">
              <div
                style={{
                  background: "linear-gradient(135deg, #0e497b, #2563eb)",
                  color: "#ffffff",
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 16,
                  boxShadow: "0 3px 10px rgba(14,73,123,0.25)",
                }}
              >
                📊
              </div>
              <span style={{ fontWeight: 800, color: "#0e497b", fontSize: 17, letterSpacing: "-0.2px" }}>
                Leave Entitlements & Balances
              </span>
            </div>
          }
          bordered={false}
          style={{
            borderRadius: 20,
            border: "1px solid #e2e8f0",
            boxShadow: "0 4px 24px rgba(15,23,42,0.05)",
            background: "#ffffff",
          }}
          bodyStyle={{ padding: "24px" }}
        >
          <Row gutter={[24, 24]}>
            {/* GAUGECARD 1: CASUAL LEAVE (CL) */}
            <Col xs={24} md={8}>
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: 16,
                  border: "1px solid #e2e8f0",
                  padding: "20px 16px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <div>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                    <div
                      style={{
                        background: "linear-gradient(135deg, #059669, #10b981)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        boxShadow: "0 2px 6px rgba(5,150,105,0.2)",
                      }}
                    >
                      🏖️
                    </div>
                    <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                      Casual Leave (CL)
                    </span>
                  </div>

                  <div className="my-2">
                    <Progress
                      type="dashboard"
                      percent={clPct}
                      width={120}
                      strokeColor={{ "0%": "#10b981", "100%": "#059669" }}
                      trailColor="#e2e8f0"
                      strokeWidth={9}
                      format={() => (
                        <div style={{ marginTop: "-2px" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: "#059669" }}>{clBal}</div>
                          <div style={{ fontSize: 10.5, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Days Left</div>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Allotted</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#0e497b" }}>{clTotal} Days</div>
                  </div>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{clTaken} Days</div>
                  </div>
                </div>
              </div>
            </Col>

            {/* GAUGECARD 2: SICK LEAVE (SL) */}
            <Col xs={24} md={8}>
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: 16,
                  border: "1px solid #e2e8f0",
                  padding: "20px 16px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <div>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                    <div
                      style={{
                        background: "linear-gradient(135deg, #2563eb, #3b82f6)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        boxShadow: "0 2px 6px rgba(37,99,235,0.2)",
                      }}
                    >
                      🤒
                    </div>
                    <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                      Sick Leave (SL)
                    </span>
                  </div>

                  <div className="my-2">
                    <Progress
                      type="dashboard"
                      percent={slPct}
                      width={120}
                      strokeColor={{ "0%": "#3b82f6", "100%": "#1d4ed8" }}
                      trailColor="#e2e8f0"
                      strokeWidth={9}
                      format={() => (
                        <div style={{ marginTop: "-2px" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: "#2563eb" }}>{slBal}</div>
                          <div style={{ fontSize: 10.5, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Days Left</div>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Allotted</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#0e497b" }}>{slTotal} Days</div>
                  </div>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{slTaken} Days</div>
                  </div>
                </div>
              </div>
            </Col>

            {/* GAUGECARD 3: COMP / WEEK OFF */}
            <Col xs={24} md={8}>
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: 16,
                  border: "1px solid #e2e8f0",
                  padding: "20px 16px",
                  textAlign: "center",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
                }}
              >
                <div>
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                    <div
                      style={{
                        background: "linear-gradient(135deg, #7c3aed, #a855f7)",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 8,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 15,
                        boxShadow: "0 2px 6px rgba(124,58,237,0.2)",
                      }}
                    >
                      🛌
                    </div>
                    <span style={{ fontWeight: 800, fontSize: 15, color: "#0f172a" }}>
                      Comp / Week Off
                    </span>
                  </div>

                  <div className="my-2">
                    <Progress
                      type="dashboard"
                      percent={compWeekPct}
                      width={120}
                      strokeColor={{ "0%": "#a855f7", "100%": "#6d28d9" }}
                      trailColor="#e2e8f0"
                      strokeWidth={9}
                      format={() => (
                        <div style={{ marginTop: "-2px" }}>
                          <div style={{ fontSize: 24, fontWeight: 900, color: "#7c3aed" }}>{compWeekBalTotal}</div>
                          <div style={{ fontSize: 10, fontWeight: 800, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>Off Left</div>
                        </div>
                      )}
                    />
                  </div>

                  <div className="d-flex justify-content-around py-1.5 mt-1" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #e2e8f0" }}>
                    <div>
                      <span style={{ fontSize: 11, color: "#64748b" }}>Comp Bal: </span>
                      <strong style={{ fontSize: 13, color: "#7c3aed", fontWeight: 800 }}>{compoffBal} d</strong>
                    </div>
                    <div style={{ width: 1, background: "#e2e8f0" }} />
                    <div>
                      <span style={{ fontSize: 11, color: "#64748b" }}>Week Bal: </span>
                      <strong style={{ fontSize: 13, color: "#7c3aed", fontWeight: 800 }}>{weekoffBal} d</strong>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between gap-2 mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Comp Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{compoffTaken} Days</div>
                  </div>
                  <div className="flex-fill py-2 px-2" style={{ background: "#ffffff", borderRadius: 10, border: "1px solid #cbd5e1" }}>
                    <div style={{ fontSize: 11, color: "#64748b", fontWeight: 600 }}>Week Taken</div>
                    <div style={{ fontSize: 14.5, fontWeight: 800, color: "#d97706" }}>{weekoffTaken} Days</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </div>
    );
  };

  const menuItems = [
    { key: "home", icon: <DashboardOutlined />, label: "Dashboard" },
    {
      key: "attendance",
      icon: <FieldTimeOutlined />,
      label: "Attendance",
      children: [
        {
          key: "myattendance",
          icon: <ScheduleOutlined />,
          label: "View Attendance",
        },
        authData?.employee?.is_ot && {
          key: "otavail",
          icon: <HourglassOutlined />,
          label: "Over Time Apply",
        },
        // {
        //   key: "myrfc",
        //   icon: <HourglassOutlined />,
        //   label: "My Requests",
        // },
        {
          key: "applyOnduty",
          icon: <HourglassOutlined />,
          label: "Apply On Duty",
        },
        {
          key: "appliedOnDuty",
          icon: <HourglassOutlined />,
          label: "Applied On Duty",
        },
      ],
    },

    {
      key: "leaveManagement",
      icon: <CalendarFilled />,
      label: "Leave Management",
      children: [
        { key: "leaves", icon: <FileProtectOutlined />, label: "Leaves" },
        { key: "permissions", icon: <ClockCircleFilled />, label: "Permissions" },
        { key: "offDayDutyApply", icon: <RedoOutlined />, label: "Off Day Working" },
        { key: "holidays", icon: <GiftOutlined />, label: "Holidays" },
      ],
    },

    { key: "payslip", icon: <WalletOutlined />, label: "Payslip" },

    (showMRF || isSuperUser) && {
      key: "teamdetails",
      icon: <TeamOutlined />,
      label: "Team Details",
      children: [
        { key: "teamMembers", icon: <FileDoneOutlined />, label: "Team Members" },
        {
          key: "attendancee",
          icon: <ClusterOutlined />,
          label: "Attendance",
          children: [
            { key: "teamattendance", icon: <BarChartOutlined />, label: "Team Attendance" },
            // { key: "rfc", icon: <ExclamationCircleOutlined />, label: "Request for Consideration" },
            {
              key: "otapproval",
              icon: <CheckSquareOutlined />,
              label: "Over Time Requests",
            },
            {
              key: "onduty",
              icon: <CheckSquareOutlined />,
              label: "Onduty Requests",
            },
          ],
        },
        {
          key: "leave",
          icon: <UsergroupAddOutlined />,
          label: "Team Leave Management",
          children: [
            { key: "leaveRequests", icon: <InboxOutlined />, label: "Leave Requests" },
            { key: "permissionRequests", icon: <FieldBinaryOutlined />, label: "Permission Requests" },
            { key: "compoffRequests", icon: <SyncOutlined />, label: "Team off day workings" },
          ],
        },
        {
          key: "lifecycle",
          icon: <ApartmentOutlined />,
          label: "Employee Life Cycle",
          children: [
            { key: "teamemployement", icon: <ExperimentOutlined />, label: "Probation" },
            { key: "overall", icon: <SafetyCertificateOutlined />, label: "Confirmed" },
            { key: "noticeperiod", icon: <SafetyCertificateOutlined />, label: "Notice Period" },
            { key: "pips", icon: <WarningOutlined />, label: "Raised PIP Requests" },
            {
              key: "resignationRequests",
              icon: <FileTextOutlined />,
              label: "Resignation Requests",
            },
          ],
        },
      ],
    },

    // {
    //   key: "showselfassessments",
    //   icon: <LineChartOutlined />,
    //   label: "Team Assessments",
    // },

    {
      key: "recruitment",
      icon: <UserAddOutlined />,
      label: "Recruitment",
      children: [
        (showMRF && !isSuperUser) && {
          key: "applyMRF",
          icon: <FileAddOutlined />,
          label: "Apply MRF",
        },
        (showMRF && !isSuperUser) && {
          key: "viewRequisitions",
          icon: <FileSearchOutlined />,
          label: "View Requisitions",
        },
        { key: "interview", icon: <AuditOutlined />, label: "Interview & Assessment" },
      ],
    },

    {
      key: "ticketingSystem",
      icon: <NotificationOutlined />,
      label: "Ticketing System",
      children: [

        { key: "raiseTicket", icon: <PlusCircleOutlined />, label: "Raise Ticket" },
        { key: "viewTicket", icon: <FolderViewOutlined />, label: "View Ticket" },
        (authData?.employee?.department === 48 || authData?.employee.role === 2) && {
          key: "tickets",
          icon: <NotificationOutlined />,
          label: "Raised Tickets",
        },
      ],
    },

    authData?.pending_self_assessment && {
      key: "selfAssessment",
      icon: <ThunderboltOutlined />,
      label: <span className="glow-text">Self Assessment</span>,
    },

    // {
    //   key: "orgchart",
    //   icon: <ApartmentOutlined />,
    //   label: "ORG Chart",
    // },

    {
      key: "resignation",
      icon: <MoreOutlined />,
      label: "Others",
      children: [
        { key: "resignation", icon: <LogoutOutlined />, label: "Apply Resignation" },
        authData?.assigned_dept_head_id && {
          key: "NocClearence",
          icon: <FileDoneOutlined />,
          label: "NOC Clearance",
        },
        authData?.is_exit_interview_triggered && {
          key: "exitInterview",
          icon: <FormOutlined />,
          label: "Exit Interview",
        },
      ],
    },
    authData?.employee?.id === 45 && {
      key: "raiseVersionUpdate", icon: <PlusCircleOutlined />, label: "Version Update", children: [
        { key: "raiseUpdate", icon: <PlusCircleOutlined />, label: "Update Version" },
        { key: "viewVersion", icon: <PlusCircleOutlined />, label: "View App Versions" }
      ]
    },
  ];



  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return showWelcome ? (
          <Welcome />
        ) : (
          <>
            {
              selectedMenu === "profile" ? (
                <EmployeeProfile onBack={handleBack} />
              ) : (
                <motion.div
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  style={{
                    background: "linear-gradient(180deg, #f0f4f8 0%, #e8edf5 100%)",
                    minHeight: "100vh",
                    padding: "0 0 24px",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  {authData?.your_under_pip && (
                    <div className="pip-alert-banner">
                      <span style={{ fontSize: 24, flexShrink: 0 }}>⚠️</span>
                      <div>
                        <div style={{ fontWeight: 800, color: "#92400e", fontSize: isMobile ? 13 : 15, lineHeight: 1.3 }}>
                          You are currently under a Performance Improvement Plan (PIP)
                        </div>
                        <div style={{ fontWeight: 600, color: "#b45309", fontSize: 12.5, marginTop: 2 }}>
                          {authData?.pip_days_remaining} days remaining for your review
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="container-fluid px-0" style={{ maxWidth: "1600px", margin: "0 auto" }}>
                    {/* HERO PROFILE BANNER — Framer Motion Executive Glassmorphism Card */}
                    <motion.div
                      className="emp-hero-banner mb-4"
                      initial={{ opacity: 0, y: 16 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.45, ease: "easeOut" }}
                    >
                      {/* TOP SECTION: AVATAR + USER INFO + STATUS */}
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 pb-3">
                        <div className="d-flex align-items-center" style={{ gap: "22px" }}>
                          {/* Executive Dual-Ring Avatar with Spring Hover */}
                          <motion.div
                            className="emp-avatar-wrapper"
                            whileHover={{ scale: 1.06 }}
                            whileTap={{ scale: 0.96 }}
                            transition={{ type: "spring", stiffness: 350, damping: 20 }}
                          >
                            <div className="emp-avatar-ring">
                              <img
                                src={authData?.employee?.photo ? (authData.employee.photo.startsWith("http") ? authData.employee.photo : `${backUrl}${authData.employee.photo.startsWith('/') ? '' : '/'}${authData.employee.photo}`) : UserImg}
                                alt="Profile"
                                onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                className="emp-avatar-img"
                              />
                            </div>
                            <div className="emp-online-status-dot" title="Online Active" />
                          </motion.div>

                          {/* Greeting & Subtitle Badges */}
                          <div className="d-flex flex-column justify-content-center">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                              <span style={{ color: "#ffffff", fontWeight: 900, fontSize: isMobile ? 18 : 23, letterSpacing: "-0.5px", lineHeight: 1.2, textShadow: "0 2px 8px rgba(0,0,0,0.18)" }}>
                                Welcome back, {authData?.employee?.first_name || 'Employee'}!
                              </span>
                              <motion.span animate={{ rotate: [0, 14, -8, 14, 0] }} transition={{ repeat: Infinity, repeatDelay: 4, duration: 1.2 }}>
                                👋
                              </motion.span>
                            </div>

                            <div className="d-flex align-items-center gap-2 flex-wrap mt-2" style={{ fontSize: 13, fontWeight: 600 }}>
                              {(authData?.employee?.designation_name || authData?.employee?.role_name) && (
                                <span style={{ fontWeight: 700, color: "rgba(255,255,255,0.95)", display: "inline-flex", alignItems: "center", gap: 5 }}>
                                  <ShieldCheck style={{ width: 14, height: 14, color: "#38bdf8" }} />
                                  {authData?.employee?.designation_name || authData?.employee?.role_name}
                                </span>
                              )}

                              {(authData?.employee?.department_name || authData?.employee?.department) && (
                                <>
                                  <span style={{ color: "rgba(255,255,255,0.35)" }}>•</span>
                                  <span style={{ color: "rgba(255,255,255,0.85)" }}>
                                    🏢 {authData?.employee?.department_name || authData?.employee?.department}
                                  </span>
                                </>
                              )}

                              {(authData?.employee?.emp_code || authData?.employee?.emp_id || authData?.employee?.employee_id) && (
                                <>
                                  <span style={{ color: "rgba(255,255,255,0.35)" }}>•</span>
                                  <span
                                    style={{
                                      background: "rgba(255,255,255,0.16)",
                                      border: "1px solid rgba(255,255,255,0.28)",
                                      color: "#ffffff",
                                      borderRadius: 8,
                                      padding: "2px 10px",
                                      fontSize: 11.5,
                                      fontWeight: 800,
                                      backdropFilter: "blur(6px)",
                                    }}
                                  >
                                    ID: {authData?.employee?.emp_code || authData?.employee?.emp_id || authData?.employee?.employee_id}
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Top Right: Today Date & Mode Badge */}
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <div
                            style={{
                              background: "rgba(0, 0, 0, 0.22)",
                              border: "1px solid rgba(255, 255, 255, 0.22)",
                              color: "rgba(255, 255, 255, 0.95)",
                              borderRadius: 30,
                              padding: "6px 16px",
                              fontSize: 12,
                              fontWeight: 700,
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              backdropFilter: "blur(10px)",
                            }}
                          >
                            <LucideCalendar style={{ width: 14, height: 14, color: "#38bdf8" }} />
                            <span>{new Date().toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}</span>
                          </div>

                          <span className="emp-mode-badge">
                            {dashboardMode === "team" ? "👑 TEAM LEAD" : "👤 MY HUB"}
                          </span>
                        </div>
                      </div>

                      {/* BOTTOM SECTION: EXECUTIVE QUICK SHORTCUTS */}
                      <div
                        className="pt-3 d-flex align-items-center justify-content-between flex-wrap gap-2"
                        style={{ borderTop: "1px solid rgba(255, 255, 255, 0.12)" }}
                      >
                        <div style={{ fontSize: 11.5, textTransform: "uppercase", letterSpacing: "1px", fontWeight: 800, color: "rgba(255, 255, 255, 0.75)", display: "flex", alignItems: "center", gap: 6 }}>
                          <Sparkles style={{ width: 14, height: 14, color: "#f59e0b" }} />
                          <span>QUICK SHORTCUTS</span>
                        </div>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          {dashboardMode === "team" ? (
                            <>
                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button
                                  type="text"
                                  onClick={() => setSelectedMenu("leaveRequests")}
                                  className="emp-action-tile-btn"
                                  style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}
                                >
                                  <InboxOutlined style={{ fontSize: 15 }} />
                                  <span>Leave Req</span>
                                  {(teamPendingData?.counts?.leave || 0) > 0 && (
                                    <span style={{ background: "#ef4444", color: "#fff", borderRadius: 20, fontSize: 10.5, fontWeight: 900, padding: "1px 8px", minWidth: 20, textAlign: "center" }}>
                                      {teamPendingData?.counts?.leave}
                                    </span>
                                  )}
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button
                                  type="text"
                                  onClick={() => setSelectedMenu("permissionRequests")}
                                  className="emp-action-tile-btn"
                                  style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}
                                >
                                  <ClockCircleOutlined style={{ fontSize: 15 }} />
                                  <span>Permissions</span>
                                  {(teamPendingData?.counts?.permission || 0) > 0 && (
                                    <span style={{ background: "#3b82f6", color: "#fff", borderRadius: 20, fontSize: 10.5, fontWeight: 900, padding: "1px 8px", minWidth: 20, textAlign: "center" }}>
                                      {teamPendingData?.counts?.permission}
                                    </span>
                                  )}
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button
                                  type="text"
                                  onClick={() => setSelectedMenu("compoffRequests")}
                                  className="emp-action-tile-btn"
                                  style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}
                                >
                                  <SyncOutlined style={{ fontSize: 15 }} />
                                  <span>Off Day</span>
                                  {(teamPendingData?.counts?.off_day_working || 0) > 0 && (
                                    <span style={{ background: "#f59e0b", color: "#fff", borderRadius: 20, fontSize: 10.5, fontWeight: 900, padding: "1px 8px", minWidth: 20, textAlign: "center" }}>
                                      {teamPendingData?.counts?.off_day_working}
                                    </span>
                                  )}
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button
                                  type="text"
                                  onClick={() => setSelectedMenu("teamattendance")}
                                  className="emp-action-primary-btn"
                                  style={{ height: 38, padding: "0 20px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}
                                >
                                  <Users style={{ width: 15, height: 15 }} />
                                  <span>Team Roster</span>
                                </Button>
                              </motion.div>
                            </>
                          ) : (
                            <>
                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button type="text" onClick={() => setSelectedMenu("profile")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                                  <LucideUser style={{ width: 15, height: 15 }} />
                                  <span>Profile</span>
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button type="text" onClick={() => setSelectedMenu("myattendance")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                                  <LucideClock style={{ width: 15, height: 15 }} />
                                  <span>Attendance</span>
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button type="text" onClick={() => setSelectedMenu("leaves")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                                  <FileText style={{ width: 15, height: 15 }} />
                                  <span>Apply Leave</span>
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button type="text" onClick={() => setSelectedMenu("permissions")} className="emp-action-tile-btn" style={{ height: 38, padding: "0 18px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                                  <ClockCircleOutlined style={{ fontSize: 15 }} />
                                  <span>Permission</span>
                                </Button>
                              </motion.div>

                              <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.96 }}>
                                <Button type="text" onClick={() => setSelectedMenu("payslip")} className="emp-action-primary-btn" style={{ height: 38, padding: "0 20px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                                  <LucideWallet style={{ width: 15, height: 15 }} />
                                  <span>Payslip</span>
                                </Button>
                              </motion.div>
                            </>
                          )}
                        </div>
                      </div>
                    </motion.div>

                    {/* DYNAMIC CONTENT SWITCHING BASED ON MODE */}
                    {dashboardMode === "team" ? (
                      /* EXECUTIVE TEAM COMMAND HUB */
                      <div className="d-flex flex-column gap-4 mb-4">
                        {/* 1. ACTIVITY RINGS & REAL-TIME METRICS */}
                        <Card
                          bordered={false}
                          style={{
                            borderRadius: 22,
                            border: "1px solid #e2e8f0",
                            boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                            background: "#ffffff",
                          }}
                          bodyStyle={{ padding: "24px" }}
                        >
                          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                            <div>
                              <div style={{ fontWeight: 900, color: "#0f172a", fontSize: 18, marginBottom: 2 }}>
                                Team Activity Rings & Real-Time Metrics
                              </div>
                              <div style={{ fontSize: 12.5, color: "#64748b", fontWeight: 700 }}>
                                Live Subordinate Attendance & Availability Status
                              </div>
                            </div>
                            <Tag color="blue" style={{ borderRadius: 12, padding: "4px 14px", fontWeight: 800, fontSize: 12 }}>
                              👥 Total Team: {teamAttendanceData?.counts?.total_members ?? checkData?.team_count ?? 0} Members
                            </Tag>
                          </div>

                          <Row gutter={[24, 24]} align="middle">
                            {/* RECHARTS MULTI-SEGMENT ACTIVITY DONUT RING */}
                            <Col xs={24} md={9} className="d-flex flex-column align-items-center justify-content-center">
                              {(() => {
                                 const c = teamAttendanceData?.counts || {};
                                 const total = c.total_members ?? checkData?.team_count ?? 0;
                                 const present = c.present ?? 0;
                                 const late = c.late_in ?? 0;
                                 const permission = c.permission ?? 0;
                                 const onduty = c.onduty ?? 0;
                                 const totalLeaves = (c.casual_leave || 0) + (c.sick_leave || 0) + (c.earned_leave || 0) + (c.compoff_leave || 0) + (c.lop_leave || 0);
                                 const unplannedAbsent = c.unplanned_absent ?? c.absent ?? 0;
                                 const weekoff = c.weekoff_leave || c.week_off || c.weekoff || 0;
                                 const compoff = c.compoff_leave || c.comp_off || c.compoff || 0;

                                 const activeData = [
                                   { name: "Present", value: present, color: "#10b981" },
                                   { name: "On Leaves", value: totalLeaves, color: "#ef4444" },
                                   { name: "Week Off", value: weekoff, color: "#eab308" },
                                   { name: "Comp Off", value: compoff, color: "#ca8a04" },
                                   { name: "Late In", value: late, color: "#f59e0b" },
                                   { name: "Permission", value: permission, color: "#3b82f6" },
                                   { name: "On Duty", value: onduty, color: "#8b5cf6" },
                                   { name: "Absent", value: unplannedAbsent, color: "#dc2626" },
                                 ].filter(d => d.value > 0);

                                 const pieData = activeData.length > 0 ? activeData : [{ name: "No Data", value: 1, color: "#cbd5e1" }];

                                 return (
                                   <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                     <div style={{ position: "relative", width: 180, height: 180, margin: "0 auto" }}>
                                       <ResponsiveContainer width="100%" height="100%">
                                         <PieChart>
                                           <Pie
                                             data={pieData}
                                             cx="50%"
                                             cy="50%"
                                             innerRadius={58}
                                             outerRadius={80}
                                             paddingAngle={4}
                                             dataKey="value"
                                             stroke="none"
                                           >
                                             {pieData.map((entry, index) => (
                                               <Cell key={`cell-${index}`} fill={entry.color} />
                                             ))}
                                           </Pie>
                                           <RechartsTooltip
                                             formatter={(val, name) => [`${val} Members`, name]}
                                             contentStyle={{ borderRadius: 10, fontWeight: 700, boxShadow: "0 6px 18px rgba(0,0,0,0.12)" }}
                                           />
                                         </PieChart>
                                       </ResponsiveContainer>

                                       {/* CENTER OVERLAY */}
                                       <div
                                         style={{
                                           position: "absolute",
                                           top: "50%",
                                           left: "50%",
                                           transform: "translate(-50%, -50%)",
                                           textAlign: "center",
                                           pointerEvents: "none"
                                         }}
                                       >
                                         <div style={{ fontSize: 26, fontWeight: 900, color: "#0f172a", lineHeight: 1 }}>{total}</div>
                                         <div style={{ fontSize: 9.5, color: "#64748b", fontWeight: 800, marginTop: 2, letterSpacing: "0.05em" }}>TOTAL STAFF</div>
                                         <div style={{ fontSize: 9.5, color: "#059669", fontWeight: 800, marginTop: 2, background: "#ecfdf5", border: "1px solid #a7f3d0", padding: "1px 8px", borderRadius: 10 }}>
                                           {total > 0 ? Math.round((present / total) * 100) : 0}% Turnout
                                         </div>
                                       </div>
                                     </div>

                                     {/* INLINE STATUS BADGES BELOW DONUT */}
                                     <div style={{ display: "flex", flexWrap: "wrap", gap: 6, justifyContent: "center", marginTop: 10 }}>
                                       {activeData.map(item => (
                                         <span
                                           key={item.name}
                                           style={{
                                             fontSize: 11,
                                             fontWeight: 800,
                                             color: item.color,
                                             background: `${item.color}15`,
                                             border: `1px solid ${item.color}40`,
                                             padding: "2px 9px",
                                             borderRadius: 12,
                                             display: "inline-flex",
                                             alignItems: "center",
                                             gap: 4
                                           }}
                                         >
                                           <span style={{ width: 6, height: 6, borderRadius: "50%", background: item.color }} />
                                           {item.name}: {item.value}
                                         </span>
                                       ))}
                                     </div>
                                   </div>
                                 );
                               })()}
                            </Col>

                            {/* SIDE-BY-SIDE REAL-TIME METRIC CARDS (15-SPAN GRID) */}
                            <Col xs={24} md={15}>
                              {(() => {
                                const c = teamAttendanceData?.counts || {};
                                const present = c.present ?? 0;
                                const permission = c.permission ?? 0;
                                const onduty = c.onduty ?? 0;
                                const late = c.late_in ?? 0;
                                const pendingTotal = (teamPendingData?.counts?.leave || 0) + (teamPendingData?.counts?.permission || 0) + (teamPendingData?.counts?.onduty || 0) + (teamPendingData?.counts?.off_day_working || 0);

                                const allAbsent = teamAttendanceData?.absent_members || [];

                                const checkIsWeekOff = (m) => {
                                  const t = (m.leave_type || m.status || "").toUpperCase();
                                  return t.includes("WEEK") || t.includes("OFF DAY") || t === "WO" || t.includes("WEEKOFF");
                                };
                                const checkIsCompOff = (m) => {
                                  const t = (m.leave_type || m.status || "").toUpperCase();
                                  return t.includes("COMP") || t.includes("CO");
                                };

                                const weekoffMembers = teamAttendanceData?.weekoff_members?.length > 0 ? teamAttendanceData.weekoff_members : allAbsent.filter(checkIsWeekOff);
                                const compoffMembers = teamAttendanceData?.compoff_members?.length > 0 ? teamAttendanceData.compoff_members : allAbsent.filter(checkIsCompOff);
                                const actualOnLeaveMembers = allAbsent.filter(m => !checkIsWeekOff(m) && !checkIsCompOff(m));

                                const totalLeaves = (c.casual_leave || 0) + (c.sick_leave || 0) + (c.earned_leave || 0) + (c.lop_leave || 0) || actualOnLeaveMembers.length;
                                const weekoffCount = c.weekoff_leave || c.week_off || c.weekoff || weekoffMembers.length;
                                const compoffCount = c.compoff_leave || c.comp_off || c.compoff || compoffMembers.length;

                                return (
                                  <Row gutter={[10, 10]}>
                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "Present Subordinates Today", members: teamAttendanceData?.present_members || [], color: "#10b981" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#f0fdf4", border: "1.5px solid #bbf7d0", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#10b981", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#065f46", fontSize: 13 }}>Present</span>
                                        </div>
                                        <Tag color="green" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {present}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "Subordinates On Leave Today", members: actualOnLeaveMembers, color: "#ef4444" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#fef2f2", border: "1.5px solid #fecaca", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#ef4444", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#991b1b", fontSize: 13 }}>On Leaves</span>
                                        </div>
                                        <Tag color="red" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {totalLeaves}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "🌴 Week Off Members Today", members: weekoffMembers, color: "#eab308" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#fefce8", border: "1.5px solid #fef08a", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#eab308", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#854d0e", fontSize: 13 }}>Week Off</span>
                                        </div>
                                        <Tag color="gold" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {weekoffCount}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "⚡ Comp Off Members Today", members: compoffMembers, color: "#ca8a04" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#fef9c3", border: "1.5px solid #fef08a", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#ca8a04", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#713f12", fontSize: 13 }}>Comp Off</span>
                                        </div>
                                        <Tag color="warning" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {compoffCount}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "Permission Applications Today", members: teamAttendanceData?.permission_members || [], color: "#3b82f6" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#3b82f6", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#1e40af", fontSize: 13 }}>Permission</span>
                                        </div>
                                        <Tag color="blue" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {permission}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "On-Duty Requests Today", members: teamAttendanceData?.onduty_members || [], color: "#8b5cf6" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#f5f3ff", border: "1.5px solid #ddd6fe", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#8b5cf6", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#5b21b6", fontSize: 13 }}>On Duty</span>
                                        </div>
                                        <Tag color="purple" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {onduty}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setMemberCategoryModal({ visible: true, title: "Late In Check-ins Today", members: teamAttendanceData?.late_in_members || [], color: "#f59e0b" })}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#fffbeb", border: "1.5px solid #fde68a", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#f59e0b", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#92400e", fontSize: 13 }}>Late In</span>
                                        </div>
                                        <Tag color="gold" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {late}
                                        </Tag>
                                      </div>
                                    </Col>

                                    <Col xs={12} sm={8} md={8}>
                                      <div
                                        onClick={() => setSelectedMenu("leaveRequests")}
                                        className="d-flex align-items-center justify-content-between p-3"
                                        style={{ background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 14, cursor: "pointer", transition: "transform 0.18s ease" }}
                                        onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
                                        onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <span className="ring-legend-dot" style={{ background: "#f97316", width: 10, height: 10, borderRadius: "50%" }} />
                                          <span style={{ fontWeight: 800, color: "#9a3412", fontSize: 13 }}>Pending Requests</span>
                                        </div>
                                        <Tag color="orange" style={{ borderRadius: 10, fontWeight: 900, fontSize: 13, padding: "2px 10px", margin: 0 }}>
                                          {pendingTotal}
                                        </Tag>
                                      </div>
                                    </Col>
                                  </Row>
                                );
                              })()}
                            </Col>
                          </Row>
                        </Card>

                        {/* 3. ON LEAVES (ONLY ACTUAL LEAVES - EXCLUDING WEEK OFF & COMP OFF) */}
                        {(() => {
                          const allAbsent = teamAttendanceData?.absent_members || [];
                          const checkIsWeekOff = (m) => {
                            const t = (m.leave_type || m.status || "").toUpperCase();
                            return t.includes("WEEK") || t.includes("OFF DAY") || t === "WO" || t.includes("WEEKOFF");
                          };
                          const checkIsCompOff = (m) => {
                            const t = (m.leave_type || m.status || "").toUpperCase();
                            return t.includes("COMP") || t.includes("CO");
                          };

                          const actualOnLeaveMembers = allAbsent.filter(m => !checkIsWeekOff(m) && !checkIsCompOff(m));
                          const offDayMembers = allAbsent.filter(m => checkIsWeekOff(m) || checkIsCompOff(m));

                          return (
                            <>
                              <Card
                                title={
                                  <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                      <div style={{ width: 4, height: 18, background: "#ef4444", borderRadius: 4 }} />
                                      <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                                        On Leaves Today
                                      </span>
                                      <Tag color="red" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                                        {actualOnLeaveMembers.length}
                                      </Tag>
                                    </div>
                                    {actualOnLeaveMembers.length > 0 && (
                                      <Button
                                        type="link"
                                        size="small"
                                        style={{ fontWeight: 800, color: "#ef4444" }}
                                        onClick={() => setMemberCategoryModal({
                                          visible: true,
                                          title: "🔴 On Leave Members Today",
                                          members: actualOnLeaveMembers,
                                          color: "#dc2626"
                                        })}
                                      >
                                        View All →
                                      </Button>
                                    )}
                                  </div>
                                }
                                bordered={false}
                                style={{
                                  borderRadius: 22,
                                  border: "1px solid #e2e8f0",
                                  boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                                  background: "#ffffff",
                                  marginBottom: 16
                                }}
                                bodyStyle={{ padding: "16px 20px" }}
                              >
                                {actualOnLeaveMembers.length > 0 ? (
                                  <div className="team-avatar-scroll-container">
                                    {actualOnLeaveMembers.map((member, idx) => {
                                      const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                                      const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                                      const leaveTypeStr = (member.leave_type || member.status || "Leave").trim();

                                      return (
                                        <div
                                          className="team-member-avatar-card"
                                          key={member.id || idx}
                                          onClick={() => setMemberCategoryModal({
                                            visible: true,
                                            title: `🔴 ${member.name || member.full_name}`,
                                            members: [member],
                                            color: "#dc2626"
                                          })}
                                        >
                                          <div className="team-member-avatar-box">
                                            <img
                                              src={fullUrl}
                                              alt={member.name || "Member"}
                                              onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                              className="team-member-avatar-img"
                                            />
                                            <div className="team-member-status-dot leave">✕</div>
                                          </div>
                                          <div className="team-member-name-label">
                                            {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                                          </div>
                                          <div className="team-member-sub-label">
                                            {leaveTypeStr}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                ) : (
                                  <div className="py-3 text-center text-muted" style={{ fontSize: 13, fontWeight: 600 }}>
                                    🎉 No team members are on leave today.
                                  </div>
                                )}
                              </Card>

                              {/* DEDICATED WEEK OFF & COMP OFF AVATAR SECTION */}
                              {offDayMembers.length > 0 && (
                                <Card
                                  title={
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div className="d-flex align-items-center gap-2">
                                        <div style={{ width: 4, height: 18, background: "#eab308", borderRadius: 4 }} />
                                        <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                                          Week Off & Comp Off Today
                                        </span>
                                        <Tag color="gold" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                                          {offDayMembers.length}
                                        </Tag>
                                      </div>
                                      <Button
                                        type="link"
                                        size="small"
                                        style={{ fontWeight: 800, color: "#b45309" }}
                                        onClick={() => setMemberCategoryModal({
                                          visible: true,
                                          title: "🌴 Week Off & Comp Off Members Today",
                                          members: offDayMembers,
                                          color: "#eab308"
                                        })}
                                      >
                                        View All →
                                      </Button>
                                    </div>
                                  }
                                  bordered={false}
                                  style={{
                                    borderRadius: 22,
                                    border: "1px solid #fef08a",
                                    boxShadow: "0 8px 30px rgba(234,179,8,0.06)",
                                    background: "#fffdf0",
                                    marginBottom: 16
                                  }}
                                  bodyStyle={{ padding: "16px 20px" }}
                                >
                                  <div className="team-avatar-scroll-container">
                                    {offDayMembers.map((member, idx) => {
                                      const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                                      const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                                      const leaveTypeStr = (member.leave_type || member.status || "Off Day").trim();
                                      const isComp = checkIsCompOff(member);

                                      return (
                                        <div
                                          className="team-member-avatar-card"
                                          key={member.id || idx}
                                          style={{ borderColor: "#fde047", background: "#ffffff" }}
                                          onClick={() => setMemberCategoryModal({
                                            visible: true,
                                            title: isComp ? `⚡ Comp Off: ${member.name || member.full_name}` : `🌴 Week Off: ${member.name || member.full_name}`,
                                            members: [member],
                                            color: isComp ? "#ca8a04" : "#eab308"
                                          })}
                                        >
                                          <div className="team-member-avatar-box">
                                            <img
                                              src={fullUrl}
                                              alt={member.name || "Member"}
                                              onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                              className="team-member-avatar-img"
                                            />
                                            <div
                                              className="team-member-status-dot weekoff"
                                              style={{ background: isComp ? "#ca8a04" : "#eab308", color: "#fff", fontSize: 10, fontWeight: 900 }}
                                            >
                                              {isComp ? "⚡" : "🌴"}
                                            </div>
                                          </div>
                                          <div className="team-member-name-label">
                                            {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                                          </div>
                                          <div
                                            className="team-member-sub-label"
                                            style={{ color: "#854d0e", fontWeight: 800, background: "#fef9c3", padding: "1px 6px", borderRadius: 8 }}
                                          >
                                            {leaveTypeStr}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </Card>
                              )}
                            </>
                          );
                        })()}

                        {/* 4. LATE IN TODAY (HORIZONTAL SCROLLING AVATAR CARDS) */}
                        <Card
                          title={
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center gap-2">
                                <div style={{ width: 4, height: 18, background: "#f59e0b", borderRadius: 4 }} />
                                <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                                  Late In Today
                                </span>
                                <Tag color="gold" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                                  {teamAttendanceData?.late_in_members?.length || 0}
                                </Tag>
                              </div>
                              {teamAttendanceData?.late_in_members?.length > 0 && (
                                <Button
                                  type="link"
                                  size="small"
                                  style={{ fontWeight: 800, color: "#d97706" }}
                                  onClick={() => setMemberCategoryModal({
                                    visible: true,
                                    title: "⏰ Late In Members Today",
                                    members: teamAttendanceData?.late_in_members || [],
                                    color: "#d97706"
                                  })}
                                >
                                  View All →
                                </Button>
                              )}
                            </div>
                          }
                          bordered={false}
                          style={{
                            borderRadius: 22,
                            border: "1px solid #e2e8f0",
                            boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                            background: "#ffffff",
                          }}
                          bodyStyle={{ padding: "16px 20px" }}
                        >
                          {teamAttendanceData?.late_in_members?.length > 0 ? (
                            <div className="team-avatar-scroll-container">
                              {teamAttendanceData.late_in_members.map((member, idx) => {
                                const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                                const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                                return (
                                  <div
                                    className="team-member-avatar-card"
                                    key={member.id || idx}
                                    onClick={() => setMemberCategoryModal({
                                      visible: true,
                                      title: `⏰ ${member.name || member.full_name}`,
                                      members: [member],
                                      color: "#d97706"
                                    })}
                                  >
                                    <div className="team-member-avatar-box">
                                      <img
                                        src={fullUrl}
                                        alt={member.name || "Member"}
                                        onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                        className="team-member-avatar-img"
                                      />
                                      <div className="team-member-status-dot late">⏰</div>
                                    </div>
                                    <div className="team-member-name-label">
                                      {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                                    </div>
                                    <div className="team-member-sub-label">
                                      {member.check_in_time || "Late"}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="py-3 text-center text-muted" style={{ fontSize: 13, fontWeight: 600 }}>
                              ⚡ No late check-ins recorded today.
                            </div>
                          )}
                        </Card>

                        {/* 5. PRESENT TODAY (HORIZONTAL SCROLLING AVATAR CARDS) */}
                        <Card
                          title={
                            <div className="d-flex align-items-center justify-content-between">
                              <div className="d-flex align-items-center gap-2">
                                <div style={{ width: 4, height: 18, background: "#10b981", borderRadius: 4 }} />
                                <span style={{ fontWeight: 900, color: "#0f172a", fontSize: 16 }}>
                                  Present Today
                                </span>
                                <Tag color="green" style={{ borderRadius: 10, fontWeight: 800, fontSize: 11, margin: 0 }}>
                                  {teamAttendanceData?.present_members?.length || 0}
                                </Tag>
                              </div>
                              {teamAttendanceData?.present_members?.length > 0 && (
                                <Button
                                  type="link"
                                  size="small"
                                  style={{ fontWeight: 800, color: "#059669" }}
                                  onClick={() => setMemberCategoryModal({
                                    visible: true,
                                    title: "🟢 Present Members Today",
                                    members: teamAttendanceData?.present_members || [],
                                    color: "#059669"
                                  })}
                                >
                                  View All →
                                </Button>
                              )}
                            </div>
                          }
                          bordered={false}
                          style={{
                            borderRadius: 22,
                            border: "1px solid #e2e8f0",
                            boxShadow: "0 8px 30px rgba(15,23,42,0.06)",
                            background: "#ffffff",
                          }}
                          bodyStyle={{ padding: "16px 20px" }}
                        >
                          {teamAttendanceData?.present_members?.length > 0 ? (
                            <div className="team-avatar-scroll-container">
                              {teamAttendanceData.present_members.map((member, idx) => {
                                const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                                const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                                return (
                                  <div
                                    className="team-member-avatar-card"
                                    key={member.id || idx}
                                    onClick={() => setMemberCategoryModal({
                                      visible: true,
                                      title: `🟢 ${member.name || member.full_name}`,
                                      members: [member],
                                      color: "#059669"
                                    })}
                                  >
                                    <div className="team-member-avatar-box">
                                      <img
                                        src={fullUrl}
                                        alt={member.name || "Member"}
                                        onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                        className="team-member-avatar-img"
                                      />
                                      <div className="team-member-status-dot present">✓</div>
                                    </div>
                                    <div className="team-member-name-label">
                                      {member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`}
                                    </div>
                                    <div className="team-member-sub-label">
                                      {member.check_in_time || "Present"}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="py-3 text-center text-muted" style={{ fontSize: 13, fontWeight: 600 }}>
                              👥 No present members checked in yet today.
                            </div>
                          )}
                        </Card>
                      </div>
                    ) : (
                      /* SELF VIEW CONTENT */
                      <div className="d-flex flex-column gap-4 mb-4">
                        <div className="row g-4 align-items-stretch">
                          {/* LEFT SECTION - LEAVE CALENDAR */}
                          <div className="col-12 col-lg-8 d-flex flex-column">
                            <Card
                              bordered={false}
                              className="emp-premium-card"
                              style={{ flex: 1, width: "100%" }}
                              bodyStyle={{ padding: isMobile ? "12px" : "20px 20px 24px" }}
                            >
                              <div style={{ width: "100%", paddingBottom: "8px" }}>
                                <LeaveCalendar />
                              </div>
                            </Card>
                          </div>

                          {/* RIGHT SECTION - DISTINCT EVENTS CARD & ANNOUNCEMENTS CARD */}
                          <div className="col-12 col-lg-4 d-flex flex-column gap-3">
                            {/* CARD 1: EVENTS TODAY */}
                            <Card
                              bordered={false}
                              className="emp-premium-card"
                              bodyStyle={{
                                padding: isMobile ? "12px" : "16px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "12px",
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-2">
                                  <span style={{ fontSize: 18 }}>🎉</span>
                                  <span style={{ fontWeight: 800, color: "#0e497b", fontSize: 15 }}>
                                    Events Today
                                  </span>
                                </div>
                                <Button
                                  type="primary"
                                  size="small"
                                  onClick={() => setEventsModalVisible(true)}
                                  style={{
                                    backgroundColor: "#0E497B",
                                    borderColor: "#0E497B",
                                    borderRadius: "14px",
                                    fontWeight: 600,
                                    fontSize: 11.5,
                                  }}
                                >
                                  View ({celebrations.birthdays.length + celebrations.work_anniversaries.length})
                                </Button>
                              </div>

                              {celebrations.birthdays.length === 0 && celebrations.work_anniversaries.length === 0 ? (
                                <div style={{ background: "#f8fafc", borderRadius: 10, padding: "12px 14px", color: "#64748b", fontSize: 12.5, fontStyle: "italic" }}>
                                  🎈 No birthdays or work anniversaries today.
                                </div>
                              ) : (
                                <div
                                  className="d-flex flex-column gap-2"
                                  style={{
                                    maxHeight: celebrations.birthdays.length + celebrations.work_anniversaries.length > 3 ? "240px" : "none",
                                    overflowY: "auto",
                                  }}
                                >
                                  {celebrations.birthdays.map((emp) => (
                                    <div key={emp.id} className="d-flex align-items-center justify-content-between p-2" style={{ background: "#fff5f5", border: "1px solid #ffe3e3", borderRadius: 10, cursor: "pointer" }} onClick={() => setEventsModalVisible(true)}>
                                      <div className="d-flex align-items-center gap-2">
                                        <span style={{ fontSize: 16 }}>🎂</span>
                                        <span style={{ fontWeight: 700, fontSize: 13, color: "#c92a2a" }}>
                                          {emp.full_name || `${emp.user?.first_name || ''} ${emp.user?.last_name || ''}`.trim() || "Employee"}
                                        </span>
                                      </div>
                                      <Tag color="pink" style={{ fontSize: 11, fontWeight: 700, borderRadius: 10, margin: 0 }}>Birthday</Tag>
                                    </div>
                                  ))}
                                  {celebrations.work_anniversaries.map((emp) => (
                                    <div key={emp.id} className="d-flex align-items-center justify-content-between p-2" style={{ background: "#f3f0ff", border: "1px solid #e5dbff", borderRadius: 10, cursor: "pointer" }} onClick={() => setEventsModalVisible(true)}>
                                      <div className="d-flex align-items-center gap-2">
                                        <span style={{ fontSize: 16 }}>🏆</span>
                                        <span style={{ fontWeight: 700, fontSize: 13, color: "#5f3dc4" }}>
                                          {emp.full_name || `${emp.user?.first_name || ''} ${emp.user?.last_name || ''}`.trim() || "Employee"}
                                        </span>
                                      </div>
                                      <Tag color="purple" style={{ fontSize: 11, fontWeight: 700, borderRadius: 10, margin: 0 }}>Anniversary</Tag>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </Card>

                            {/* CARD 2: ANNOUNCEMENTS */}
                            <Card
                              bordered={false}
                              className="emp-premium-card"
                              style={{ flex: 1, display: "flex", flexDirection: "column" }}
                              bodyStyle={{
                                padding: isMobile ? "12px" : "16px",
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                              }}
                            >
                              <div style={{ flex: 1, width: "100%", overflowY: "auto" }}>
                                <ViewAnnouncement />
                              </div>
                            </Card>
                          </div>
                        </div>
                        {leaveDetails && <LeaveSummary data={leaveDetails} />}
                      </div>
                    )}
                  </div>

                  {/* MODALS */}
                  {/* EVENTS MODAL */}
                  <Modal
                    title={
                      <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: 20 }}>🎉</span>
                        <span style={{ fontWeight: 800, color: "#0e497b", fontSize: 18 }}>Events Today</span>
                      </div>
                    }
                    open={eventsModalVisible}
                    onCancel={() => setEventsModalVisible(false)}
                    footer={null}
                    width={isMobile ? "95%" : 750}
                    centered
                    bodyStyle={{ padding: "20px" }}
                  >
                    {celebrations.birthdays.length === 0 &&
                      celebrations.work_anniversaries.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "30px 20px", color: "#64748b" }}>
                        <div style={{ fontSize: 40, marginBottom: 8 }}>🎈</div>
                        <div style={{ fontSize: 16, fontWeight: 700 }}>No Events Today</div>
                        <div style={{ fontSize: 13, color: "#94a3b8" }}>Check back tomorrow for new birthdays and work anniversaries!</div>
                      </div>
                    ) : (
                      <div className="d-flex flex-column gap-3">
                        {celebrations.birthdays.length > 0 && (
                          <Card
                            title={<span style={{ fontWeight: 800, color: "#0e497b" }}>🎂 Birthdays Today ({celebrations.birthdays.length})</span>}
                            size="small"
                            bordered={false}
                            style={{ background: "#fff5f5", border: "1px solid #ffe3e3", borderRadius: 12 }}
                            bodyStyle={{ padding: 14 }}
                          >
                            <div className="d-flex flex-column gap-3">
                              {celebrations.birthdays.map((emp) => (
                                <div key={emp.id} style={{ background: "#ffffff", borderRadius: 10, padding: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }}>
                                  <ViewBirthDay employee={emp} />
                                </div>
                              ))}
                            </div>
                          </Card>
                        )}

                        {celebrations.work_anniversaries.length > 0 && (
                          <Card
                            title={<span style={{ fontWeight: 800, color: "#0e497b" }}>🏆 Work Anniversaries Today ({celebrations.work_anniversaries.length})</span>}
                            size="small"
                            bordered={false}
                            style={{ background: "#f3f0ff", border: "1px solid #e5dbff", borderRadius: 12 }}
                            bodyStyle={{ padding: 14 }}
                          >
                            <div className="d-flex flex-column gap-3">
                              {celebrations.work_anniversaries.map((emp) => (
                                <div key={emp.id} style={{ background: "#ffffff", borderRadius: 10, padding: 12, boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }}>
                                  <WorkCard employee={emp} />
                                </div>
                              ))}
                            </div>
                          </Card>
                        )}
                      </div>
                    )}
                  </Modal>

                  {/* SEND WISH MODAL */}
                  <Modal
                    title={`Send Wish to ${selectedPerson
                      ? `${selectedPerson.user.first_name} ${selectedPerson.user.last_name}`
                      : ""
                      }`}
                    open={wishModalVisible}
                    onCancel={() => setWishModalVisible(false)}
                    onOk={handleSendWish}
                    okText="Send Wish"
                    width={isMobile ? "95%" : 520}
                    style={{ top: isMobile ? 20 : undefined }}
                  >
                    <TextArea
                      rows={4}
                      placeholder="Write your message..."
                      value={wishMessage}
                      onChange={(e) => setWishMessage(e.target.value)}
                      style={{
                        borderRadius: "8px",
                      }}
                    />
                  </Modal>

                  {/* TEAM MEMBER CATEGORY DETAIL MODAL */}
                  <Modal
                    title={
                      <div className="d-flex align-items-center justify-content-between pe-4">
                        <div className="d-flex align-items-center gap-2">
                          <span style={{ color: memberCategoryModal.color, fontWeight: 900, fontSize: 16 }}>
                            {memberCategoryModal.title}
                          </span>
                        </div>
                        <Tag color="blue" style={{ borderRadius: 12, fontWeight: 800, padding: "2px 10px" }}>
                          {memberCategoryModal.members?.length || 0} Members
                        </Tag>
                      </div>
                    }
                    open={memberCategoryModal.visible}
                    onCancel={() => {
                      setMemberCategoryModal({ ...memberCategoryModal, visible: false });
                      setSearchModalQuery("");
                    }}
                    footer={null}
                    width={isMobile ? "95%" : 680}
                    centered
                    bodyStyle={{ padding: "20px" }}
                  >
                    {memberCategoryModal.members?.length > 0 && (
                      <div className="mb-3">
                        <Input
                          prefix={<SearchOutlined style={{ color: "#94a3b8" }} />}
                          placeholder="Search employee by name, code or status..."
                          value={searchModalQuery}
                          onChange={e => setSearchModalQuery(e.target.value)}
                          allowClear
                          style={{ borderRadius: 12, padding: "8px 14px", border: "1px solid #cbd5e1" }}
                        />
                      </div>
                    )}
                    {(() => {
                      const query = (searchModalQuery || "").toLowerCase();
                      const filteredMembers = (memberCategoryModal.members || []).filter(m => {
                        const name = (m.name || m.full_name || `${m.first_name || ''} ${m.last_name || ''}`).toLowerCase();
                        const code = (m.emp_code || m.employee_code || m.EmployeeCode || "").toLowerCase();
                        const leaveType = (m.leave_type || m.status || "").toLowerCase();
                        return name.includes(query) || code.includes(query) || leaveType.includes(query);
                      });

                      if (filteredMembers.length === 0) {
                        return (
                          <div className="py-5 text-center text-secondary">
                            <div style={{ fontSize: 32, marginBottom: 8 }}>👥</div>
                            <div style={{ fontWeight: 700, fontSize: 14 }}>No matching members found</div>
                            <div style={{ fontSize: 12, color: "#94a3b8" }}>Try adjusting your search criteria</div>
                          </div>
                        );
                      }

                      return (
                        <div className="d-flex flex-column gap-2 py-1" style={{ maxHeight: "440px", overflowY: "auto" }}>
                          {filteredMembers.map((member, idx) => {
                            const photoPath = member.profile_picture || member.photo || member.profile_photo || member.avatar;
                            const fullUrl = photoPath ? (photoPath.startsWith("http") ? photoPath : `${backUrl}${photoPath.startsWith('/') ? '' : '/'}${photoPath}`) : UserImg;
                            const nameStr = member.name || member.full_name || `${member.first_name || ''} ${member.last_name || ''}`.trim() || "Employee";
                            const empCodeStr = member.emp_code || member.employee_code || member.EmployeeCode || "";
                            const desigStr = member.designation || member.job_title || member.department || "Team Member";
                            
                            let rawType = (member.leave_type || member.status || "").trim();
                            let displayType = (!rawType || rawType === "-" || rawType.toLowerCase() === "null") ? (member.check_in_time ? "" : "On Leave") : rawType;
                            const upperType = displayType.toUpperCase();
                            const isWeekOff = upperType.includes("WEEK") || upperType.includes("OFF DAY") || upperType === "WO" || upperType.includes("WEEKOFF");
                            const isCompOff = upperType.includes("COMP") || upperType.includes("CO");

                            return (
                              <div
                                key={member.id || idx}
                                className="d-flex align-items-center justify-content-between p-3"
                                style={{
                                  background: "#f8fafc",
                                  borderRadius: 14,
                                  border: "1px solid #e2e8f0",
                                  transition: "all 0.18s ease"
                                }}
                                onMouseEnter={e => { e.currentTarget.style.background = "#f1f5f9"; e.currentTarget.style.borderColor = "#cbd5e1"; }}
                                onMouseLeave={e => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
                              >
                                <div className="d-flex align-items-center gap-3">
                                  <div style={{ position: "relative" }}>
                                    <img
                                      src={fullUrl}
                                      alt={nameStr}
                                      onError={(e) => { e.target.onerror = null; e.target.src = UserImg; }}
                                      style={{ width: 46, height: 46, borderRadius: "50%", objectFit: "cover", border: "2px solid #ffffff", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
                                    />
                                    <span
                                      style={{
                                        position: "absolute",
                                        bottom: 0,
                                        right: 0,
                                        width: 12,
                                        height: 12,
                                        borderRadius: "50%",
                                        background: isWeekOff ? "#eab308" : isCompOff ? "#ca8a04" : member.check_in_time ? "#10b981" : "#ef4444",
                                        border: "2px solid #ffffff"
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <div style={{ fontWeight: 800, fontSize: 14, color: "#0f172a", display: "flex", alignItems: "center", gap: 6 }}>
                                      <span>{nameStr}</span>
                                      {empCodeStr && (
                                        <span style={{ fontSize: 11, fontWeight: 700, color: "#64748b", background: "#e2e8f0", padding: "1px 6px", borderRadius: 6 }}>
                                          {empCodeStr}
                                        </span>
                                      )}
                                    </div>
                                    <div style={{ fontSize: 12, color: "#64748b", fontWeight: 600, marginTop: 2 }}>
                                      {desigStr}
                                    </div>
                                  </div>
                                </div>

                                <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end">
                                  {member.check_in_time && (
                                    <Tag color="green" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11.5, padding: "2px 8px" }}>
                                      🟢 In: {member.check_in_time}
                                    </Tag>
                                  )}
                                  {member.permission_type && (
                                    <Tag color="blue" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11.5, padding: "2px 8px" }}>
                                      ⏱️ {member.permission_type}
                                    </Tag>
                                  )}
                                  {displayType && !member.check_in_time && (
                                    <Tag
                                      color={isWeekOff ? "gold" : isCompOff ? "warning" : "red"}
                                      style={{ borderRadius: 8, fontWeight: 800, fontSize: 11.5, padding: "2px 8px" }}
                                    >
                                      {isWeekOff ? `🌴 ${displayType}` : isCompOff ? `⚡ ${displayType}` : `🔴 ${displayType}`}
                                    </Tag>
                                  )}
                                  {member.onduty_type && (
                                    <Tag color="purple" style={{ borderRadius: 8, fontWeight: 800, fontSize: 11.5, padding: "2px 8px" }}>
                                      💼 {member.onduty_type}
                                    </Tag>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })()}
                  </Modal>
                </motion.div>
              )
            }
          </>

        );

      // case "viewprofile":
      //   return <EmployeeProfile />
      case "applyMRF":
        return <CreateMrf onSubmitSuccess={() => setSelectedMenu("viewRequisitions")} />;
      case "viewRequisitions":
        return <EmployeeViewReq />;
      case "interview":
        return <InterviewPage />;
      case "holidays":
        return <Holidays />;
      case "offDayDutyApply":
        return <OffDay />;
      case "permissions":
        return <Permission />;
      case "leaves":
        return <Leaves />;
      case "leaveRequests":
        return <Teamleaves />;
      case "compoffRequests":
        return <TeamCompoff />;
      case "permissionRequests":
        return <TeamPermissions />;
      case "raiseTicket":
        return <RaiseTicket />;
      case "viewTicket":
        return <ViewTicket />;
      case "payslip":
        return <PaySlip />;
      case "teamattendance":
        return <TeamAttendance />;
      case "compoffcancel":
        return <WeekOffCancel />;
      case "myattendance":
        return <ViewEmpAttendance />;
      case "myrfc":
        return <MyRfc />;
      case "rfc":
        return <Rfc />;
      case "teamemployement":
        return <ProbationReview />;
      case "selfAssessment":
        return <SelfAssessment />;
      case "overall":
        return <OverallEmployees />;
      case "otavail":
        return <Otapplication />;
      case "otapproval":
        return <OtApprovals is_employee_view={true} />
      case "tickets":
        return <ListTickets />
      case "showselfassessments":
        return <TeamAssessment />
      case "resignation":
        return <Resignation />
      case "resignationRequests":
        return <ResignationRequests />
      case "pips":
        return <Pips />
      case "orgchart":
        return <OrgChart />
      case "NocClearence":
        return <ListNoc />
      case "exitInterview":
        return <ExitInterview />
      case "onduty":
        return <PastOnduty />
      case "teamMembers":
        return <TeamMembers />
      case "applyOnduty":
        return <OnDutyAttendance />
      case "appliedOnDuty":
        return <AppliedOnDuty />
      case "raiseUpdate":
        return <VersionUpdate />
      case "viewVersion":
        return <ViewAppVersions />
      case "profile":
        return <EmployeeProfile onBack={handleBack} />
      case "noticeperiod":
        return <NoticeEmployees/>
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader
        dashboardMode={dashboardMode}
        setDashboardMode={setDashboardMode}
        showDashboardSwitch={showMRF}
      />

      {/* Mobile toggle */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ minHeight: "calc(100vh - 64px)", background: "linear-gradient(180deg, #f0f4f8 0%, #e8edf5 100%)" }}>
        {!isMobile && (
          <Sider
            width={260}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            theme="light"
            className="emp-sider"
            style={{
              background: "#fff",
              borderRight: "1px solid #e2e8f0",
              boxShadow: "2px 0 8px rgba(15,23,42,0.04)",
              position: "fixed",
              top: 64,
              left: 0,
              bottom: 0,
              zIndex: 900,
              overflowY: "auto",
            }}
          >
            <style>{`
              .ant-menu { background: #fff !important; border-right: none !important; padding: 10px 8px !important; }
              .ant-menu-item, .ant-menu-submenu-title { font-weight: 650 !important; font-size: 13.5px !important; color: #334155 !important; border-radius: 12px !important; margin-bottom: 5px !important; transition: background-color 0.15s ease, transform 0.15s ease !important; }
              .ant-menu-item:hover, .ant-menu-submenu-title:hover { background-color: rgba(14,73,123,0.06) !important; color: #0e497b !important; transform: translateX(3px) !important; }
              .ant-menu-item-selected { background: linear-gradient(135deg, #0e497b 0%, #1d4ed8 100%) !important; color: #ffffff !important; font-weight: 800 !important; border-left: 3.5px solid #38bdf8 !important; box-shadow: 0 4px 16px rgba(14,73,123,0.3) !important; transform: translateX(3px) !important; transition: none !important; }
              .ant-menu-item-selected, .ant-menu-item-selected *, .ant-menu-item-selected .ant-menu-title-content, .ant-menu-item-selected .anticon { color: #ffffff !important; transition: none !important; }
              .ant-menu-submenu-open > .ant-menu-submenu-title { color: #0e497b !important; font-weight: 800 !important; background-color: rgba(14,73,123,0.07) !important; }
            `}</style>
            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              onClick={({ key }) => setSelectedMenu(key)}
              style={{
                height: "100%",
                borderRight: 0,
              }}
              items={menuItems}
            />
          </Sider>
        )}

        <Drawer
          title="Tabs"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{ padding: 0 }}
          footer={null}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            onClick={({ key }) => {
              setSelectedMenu(key);
              setDrawerVisible(false);
            }}
            style={{
              height: "100%",
              borderRight: 0,
              background: "#fff",
              fontWeight: "bold",
            }}
            items={menuItems}
          />
        </Drawer>

        <Layout style={{
          marginLeft: isMobile ? 0 : (collapsed ? 80 : 260),
          transition: "margin-left 0.2s ease-in-out",
          padding: isMobile ? "12px" : "20px 24px",
          background: "linear-gradient(180deg, #f0f4f8 0%, #e8edf5 100%)",
          minHeight: "calc(100vh - 64px)",
          minWidth: 0,
          width: "100%",
        }}>
          <Content style={{ background: "transparent", minWidth: 0, width: "100%" }}>{renderContent()}</Content>
        </Layout>
      </Layout>

      <Footer style={{ background: "#fff" }} />
    </Layout>
  );
}
